<template>
  <div>
    <video
      ref="videoElement"
      class="video-js"
      preload="auto"
      width="640"
      height="264"
      muted
    >
      <source
        :src="source"
        type="application/x-mpegURL"
      >
    </video>
    <div
      v-if="showError"
      class="video-error"
    >
      <div class="camera-offline-icon">
        <feather-icon
          icon="VideoOffIcon"
          size="48"
          class="error-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import videojs from 'video.js'

// eslint-disable-next-line import/no-extraneous-dependencies
require('video.js/dist/video-js.css')

export default {
  components: {
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showError: false,
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoElement, {}, () => {
      this.player.on('error', this.handleError)
      this.player.ready(() => {
        this.player.play().catch(error => {
          console.error('Error attempting to play:', error)
        })
      })
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    handleError() {
      this.showError = true
    },
  },
}
</script>

<style scoped>
.video-js {
  width: 100%;
}
.video-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.camera-offline-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-icon {
  width: 48px;
  height: 48px;
  color: #ffa600;
  stroke-width: 1.5;
}
</style>
